
module.exports = require('../../../config/runtime/paths');
